export default "__VITE_ASSET__DnpSUKL0__"